module.exports = __webpack_public_path__ + "static/img/bj.ea7e4090.svg";